// eslint-disable-next-line no-unused-vars
/**
 * @function uniqid
 * @description generate a unique randomized id like `bqrp12nha`
 * @return {string} a unique randomized ID string
 */
var uniqid = function() {
  return Math.random().toString(36).substr(2, 9);
};


/**
 * @function isDoNotTrackEnabled
 * @description cross browser DNT checking 
 * @returns `true` if DNT is enabled else `false`
 */
function isDoNotTrackEnabled(){
  if (window.doNotTrack || navigator.doNotTrack || navigator.msDoNotTrack ) {
    if (window.doNotTrack == "1" || navigator.doNotTrack == "yes" || navigator.doNotTrack == "1" || navigator.msDoNotTrack == "1") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
  return false;
}